function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".audio{fill:#fff;}"));

var _ref3 = /*#__PURE__*/React.createElement("g", {
  transform: "translate(0 -1.896)"
}, /*#__PURE__*/React.createElement("path", {
  className: "audio",
  d: "M.985,64.1A.985.985,0,0,0,0,65.084v9.487a.985.985,0,1,0,1.969,0V65.084A.985.985,0,0,0,.985,64.1Z",
  transform: "translate(0 -55.397)"
}), /*#__PURE__*/React.createElement("path", {
  className: "audio",
  d: "M43.968,38.092a.985.985,0,0,0-.985.985V54.255a.985.985,0,0,0,1.969,0V39.077A.985.985,0,0,0,43.968,38.092Z",
  transform: "translate(-38.28 -32.236)"
}), /*#__PURE__*/React.createElement("path", {
  className: "audio",
  d: "M86.951,1.9a.985.985,0,0,0-.985.985v23.1a.985.985,0,1,0,1.969,0V2.881A.985.985,0,0,0,86.951,1.9Z",
  transform: "translate(-76.561 0)"
}), /*#__PURE__*/React.createElement("path", {
  className: "audio",
  d: "M129.933,54.361a.985.985,0,0,0-.985.985V66.964a.985.985,0,1,0,1.969,0V55.346A.985.985,0,0,0,129.933,54.361Z",
  transform: "translate(-114.84 -46.725)"
}), /*#__PURE__*/React.createElement("path", {
  className: "audio",
  d: "M172.916,64.1a.985.985,0,0,0-.985.985v9.487a.985.985,0,1,0,1.969,0V65.084A.985.985,0,0,0,172.916,64.1Z",
  transform: "translate(-153.12 -55.397)"
}));

function SvgAudioIconActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20.78,
    height: 25.068,
    viewBox: "0 0 20.78 25.068",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAudioIconActive);
export default __webpack_public_path__ + "static/media/audio-icon-active.0cf624ee.svg";
export { ForwardRef as ReactComponent };